import { Dimensions, StyleSheet } from "react-native";

const { height } = Dimensions.get("screen");

const styles = StyleSheet.create({
  content: {
    height,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#ffffff"
  },
  cardStyle: {
    height: 335,
    width: 335,
    paddingTop: 36,
    alignItems: "center",
    backgroundColor: "#fffff7"
  },
  cardItem: {
    marginBottom: 9,
    width: 160,
    height: 40,
    backgroundColor: "#fffff7",
    borderRadius: 20,
    shadowColor: "#ddd",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 1,
    shadowRadius: 5,
    elevation: 2,
    marginHorizontal: 1
  },
  title: {
    fontFamily: "Poppins",
    fontWeight: "bold",
    fontSize: 18,
    color: "#666666",
    marginBottom: 62
  },
  textItem: {
    fontSize: 14,
    fontFamily: "Poppins",
    color: "#707070",
    fontWeight: "bold"
  },
  textClose: {
    fontFamily: "Poppins",
    fontSize: 18,
    fontWeight: "bold",
    color: "#707070"
  },
  buttonClose: {
    bottom: 22,
    left: 34,
    position: "absolute"
  }
});

export default styles;
